const envValue = (key: string): string | undefined => {
  const env = import.meta.env as ImportMetaEnv | undefined;
  if (!env) return undefined;
  return (env as unknown as Record<string, string | undefined>)[key];
};

export const isDataExplorerEnabled = (): boolean => {
  const env = import.meta.env as ImportMetaEnv | undefined;
  if (!env) return false;
  return envValue('VITE_ENABLE_DATA_EXPLORER') === 'true' || Boolean(env.DEV);
};

/**
 * P-06/P-07 ship behind their own default-off flags. The Data Explorer itself
 * is live, but Ask and the chart layer stay dark until the coordinator flips
 * the matching repository variable and records the change: they are enabled
 * only when the base flag is on and `VITE_ENABLE_DATA_EXPLORER_*` is exactly
 * `true`, in every build including local dev.
 */
const surfaceEnabled = (key: string): boolean =>
  isDataExplorerEnabled() && envValue(key) === 'true';

export const isDataExplorerAskEnabled = (): boolean =>
  surfaceEnabled('VITE_ENABLE_DATA_EXPLORER_ASK');

export const isDataExplorerChartsEnabled = (): boolean =>
  surfaceEnabled('VITE_ENABLE_DATA_EXPLORER_CHARTS');

/**
 * O-39: calendar-exact Ask windows ship behind their own default-off flag.
 * While off, "last 3 months" keeps the legacy N x 30-day look-back in the
 * generated SQL; when on, the planner resolves the phrase through the shared
 * `resolveTimeRange` and quotes explicit store calendar dates, the same window
 * the `resolve_time_range` MCP tool returns.
 */
export const isDataExplorerAskCalendarWindowsEnabled = (): boolean =>
  surfaceEnabled('VITE_ENABLE_DATA_EXPLORER_ASK_CALENDAR_WINDOWS');
